<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13.707"
    height="13.414"
    viewBox="0 0 13.707 13.414"
    :class="[color, direction]"
  >
    <g
      id="Component_73_1"
      data-name="Component 73 – 1"
      transform="translate(0.707 0.707)"
    >
      <path
        id="Path_2055"
        data-name="Path 2055"
        d="M-4363.537-8901.469l6,6-6,6"
        transform="translate(4363.537 8901.469)"
        fill="none"
        stroke="#2d323c"
        stroke-width="2"
      />
      <line
        id="Line_440"
        data-name="Line 440"
        y2="12"
        transform="translate(12)"
        fill="none"
        stroke="#2d323c"
        stroke-width="2"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'StopChevron',
  props: {
    direction: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      required: false,
      default: '#2d323c',
    },
  },
}
</script>

<style lang="scss" scoped>
.a {
  transition: all ease 0.3s;
  fill: #2d323c;
  transition: all ease 0.3s;
}
svg {
  transition: all ease 0.3s;
}
.left {
  transform: rotate(-180deg);
}
.right {
  transform: rotate(0deg);
}
.up {
  transform: rotate(-90deg);
}
.down {
  transform: rotate(90deg);
}

.sleet {
  &:hover {
    .a {
      fill: $strom;
    }
  }
  path,
  line {
    stroke: #d2d7dc;
  }
}
</style>
